<template>

 <v-layout>
    <v-container grid-list-md>
      <v-card>
          <v-card-title class="greyk lighten-4k">
               <h3>Dashboard</h3>
          </v-card-title>

          <v-card-text>
               <v-layout row wrap>
            <v-flex xs12 sm6>
              <v-card>
                <v-card-title primary-title style="background:darkgreen;color: white;">
                  <div>
                    <h4 class="headline mb-0">Assigned Classes</h4>
                  </div>
                </v-card-title>
                <!--<v-divider></v-divider>-->
                <v-card-text style="background:darkgreen;color: white;">
                  <v-layout row wrap class="stat-data">
                    <v-flex xs4>
                      <v-icon style="color: white">border_all</v-icon>
                    </v-flex>

                    <v-flex xs8>
                      <h2>{{myclasses.length}}</h2>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions style="background: #fafafa;color:#333">
                  <p>Number of assigned classes</p>
                </v-card-actions>
              </v-card>
            </v-flex>


            <v-flex xs12 sm6>
              <v-card>
                <v-card-title primary-title style="background:darkslategray;color: white;">
                  <div>
                    <h4 class="headline mb-0">Assigned Students</h4>
                  </div>
                </v-card-title>
                <!--<v-divider></v-divider>-->
                <v-card-text style="background:darkslategray;color: white;">
                  <v-layout row wrap class="stat-data">
                    <v-flex xs4>
                      <v-icon style="color: white">people</v-icon>
                    </v-flex>

                    <v-flex xs8>
                      <h2>{{assigned_stdCount}}</h2>
                    </v-flex>
                  </v-layout>
                </v-card-text>

                <v-card-actions style="background: #fafafa;color:#333">
                  <p>Number of assigned students</p>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
          </v-card-text>
      </v-card>
    </v-container>
    </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    layout:'teacher',
    data(){
      return{

      }
    },
    mounted(){
      this.$store.dispatch("classes/getMyClasses");
    },
     computed: {
    ...mapGetters({
      myclasses: "classes/MYCLASSES",
      errors: "classes/CLASS_ERROR",
      loading: "classes/CLASS_LOADING"
    }),

    assigned_stdCount(){
      return this.myclasses.reduce((sum,val)=>{
        return sum + parseInt(val.students.length)
      },0)
    }
  },
}

</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/teacher/dashboard.vue